var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-info",on:{"click":_vm.pesertaData}},[_vm._t("default",function(){return [_c('i',{staticClass:"fas fa-user"})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }